
export const AppCatalogLoading = () => {
  return (
    <div className="border rounded-lg p-8 text-center text-gray-500">
      Loading apps...
    </div>
  );
};
